module.exports = __webpack_public_path__ + "media/images/social-share-button/twitter-30e2baa90d4d52de1852b6dd1e4e9bd9.png";